module.exports = __webpack_public_path__ + "static/media/order_create.cf8dd9ba.jpg";